import React from 'react';
import { AppShell, Flex, useMantineTheme, Box } from '@mantine/core';
import Navbar from '../components/navbar/Navbar';
import { Footer } from '../components/Footer';

const LayoutWrapper = ({ children }: { children: JSX.Element }) => {
  const theme = useMantineTheme();
  return (
    <Flex justify="center" w="100%">
      <AppShell header={{ height: 50 }} maw={theme.breakpoints.lg} w="100%">
        <AppShell.Header
          bd="0"
          maw={theme.breakpoints.lg}
          ml="auto"
          mr="auto"
          px="md"
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.05) 0px 4px 12px',
          }}
        >
          <Navbar />
        </AppShell.Header>
        <AppShell.Main px="md">
          <Flex
            direction="column"
            style={{
              minHeight: 'calc(100vh - 50px)',
            }}
          >
            <Box style={{ flex: 1 }}>{children}</Box>
            <Box px="md" maw={theme.breakpoints.lg} ml="auto" mr="auto" mt="xl">
              <Footer />
            </Box>
          </Flex>
        </AppShell.Main>
      </AppShell>
    </Flex>
  );
};

export const getEveryoneLayout = (page: JSX.Element) => <LayoutWrapper>{page}</LayoutWrapper>;
export default LayoutWrapper;
